module.exports = __webpack_public_path__ + "static/6-07d4950bd090c1b38070cfff3d646965.png";